<template>
  <div>
    <!--IMAGE SELECTOR : Image options are predefined and the user selects one.-->
    <label class="control-label">Image</label>
    <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>

    <div class="image-selection">
      <vue-select-image
        :dataImages="dataImages"
        :selectedImages="selectedImages"
        @onselectimage="onSelectImage"
        activeClass=" selected"
      >
      </vue-select-image>
    </div>
    <input type="hidden" :name="'pieces[' + pieceIndex + '][content]'" :value="selectedImageHtml" />

    <input
      v-if="selectedImageUrl"
      type="hidden"
      :name="'pieces[' + pieceIndex + '][data][selected_image]'"
      :value="selectedImageUrl"
    />

    <div class="step-spacer"></div>
  </div>
</template>
<script>
import utils from '../../../../mixins/utils';
import VueSelectImage from 'vue-select-image';

export default {
  name: 'image-selector-piece',
  components: {VueSelectImage},
  mixins: [utils],
  props: {
    pieceIndex: {
      type: Number,
      required: true,
    },
    pieceName: {
      type: String,
      required: true,
    },
    pieceContent: {
      type: String,
      required: true,
    },
    pieceOptions: {
      type: Object,
      required: true,
    },
    pieceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedImageUrl: '',
    };
  },
  computed: {
    dataImages() {
      return (this.pieceOptions && this.pieceOptions.image_options)
        .split(',')
        .map((imageUrl, index) => ({id: `image-selector-piece-option-${index}`, src: imageUrl}));
    },
    selectedImageHtml() {
      if (!this.selectedImageUrl) {
        return '';
      }

      return `<img style='width:100%; margin:0 0 20px 0;' src='${this.selectedImageUrl}' />`;
    },
    selectedImages() {
      return this.dataImages.filter(image => image.src === this.selectedImageUrl);
    },
  },
  methods: {
    onSelectImage(image) {
      this.selectedImageUrl = image.src;
    },
  },
  created() {
    const parsedImageUrl = ((this.pieceContent ?? '').match(/<img.*src='(.*)' \/>/) ?? [])[1];
    this.selectedImageUrl = ((this.pieceData && this.pieceData.selected_image) || (this.pieceOptions && this.pieceOptions.selected_image)) ?? parsedImageUrl ?? '';
  },
};
</script>

<style lang="scss">
.vue-select-image {
  width: 100%;

  .vue-select-image__wrapper {
    margin: 10px 0;
    width: 100%;

    .vue-select-image__item {
      list-style-type: none;
      width: 25%;
      float: left;
      border: 5px solid #fff;

      .vue-select-image__thumbnail {
        outline: 5px solid transparent;
      }

      .selected {
        outline: 5px solid #66cccc;
      }
    }
  }
}
</style>
